import { configureStore, combineReducers } from "@reduxjs/toolkit";
import loginReducer       from "./login/loginSlice";
import roleReducer       from "./roles/roleReducer";
import permissionReducer from "./permissions/permissionSlice";
import userReducer from "./users/userSlice";
import paymentModeReducer from "./paymentMode/paymentModeSlice";
import expenseSlice from "./expense/expenseSlice";
import cabinetSlice from "./cabinets/cabinetSlice";
import doctorSlice from "./doctors/doctorSlice";
import regFormSlice from "./regForm/regFormSlice";
import diplomSlice from "./diploms/diplomSlice";
import medecinTypeSlice from "./medecinType/medecinTypeSlice";
import paymentSlice from "./payments/paymentSlice";
import adsInfoSlice from "./adsinfo/adsInfoSlice";
import assuranceSlice from "./assurances/assuranceSlice";
import partnerSlice from "./partners/partnerSlice";
import scientificDaySlice from "./scientificday/scientificDaySlice";
import legalAndRegulatorTextSlice from "./legal_and_regulator_text/legalAndRegulatorTextSlice";
import newsSlice from "./news/newsSlice";
import instructionSlice from "./instruction/instructionSlice";
import complaintSlice from "./complaints/complaintSlice";
import moughataaSlice from "./moughataas/moughataaSlice";

import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { companyName } from "../requestMethods";

const persistConfig = {
  key: companyName,
  version: 1,
  storage,
};

const rootReducer = combineReducers({ 
  login: loginReducer,
  roles: roleReducer,
  permissions: permissionReducer,
  users: userReducer,
  paymentModes: paymentModeReducer,
  expenses: expenseSlice,
  cabinets: cabinetSlice,
  doctors: doctorSlice,
  regForm: regFormSlice,
  diploms: diplomSlice,
  medecinType: medecinTypeSlice,
  payments: paymentSlice,
  adsInfos: adsInfoSlice,
  assurances: assuranceSlice,
  partners: partnerSlice,
  ScientificDays: scientificDaySlice,
  legalAndRegTexts: legalAndRegulatorTextSlice,
  news: newsSlice,
  instructions: instructionSlice,
  complaints: complaintSlice,
  moughataas: moughataaSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor = persistStore(store);

export type State = ReturnType<typeof rootReducer>
